<template>
    <div v-wechat-title="title" style="height: 100%">
        <crud-facecade
            ref="data-list"
            :url="url"
            :columns="columnList"
            :buttons="[]"
            :tableHeight="tableHeight"
            dialogWidth="90%"
            :addButton="{ enabled: false }"
            :updateButton="{ enabled: false }"
            @OpenDetail="OpenDetail"
            @extrabutton-click="ExtraButtonClick"
        >
            <slot slot="filter">
                <el-col :md="2" :xl="2">计费时间:</el-col>
                <el-col :md="8" :xl="7">
                    <item-input v-if="!showTime" type="daterange" v-model="rdate" :noPadding="true"></item-input>
                    <el-date-picker
                        v-if="showTime"
                        style="width: 100%"
                        size="small"
                        :clearable="false"
                        v-model="rdate"
                        format="yyyy-MM-dd HH:mm"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :default-time="[showTime + ':00', showTime + ':00']"
                    >
                    </el-date-picker>
                </el-col>
                <el-col :md="5" :xl="3">
                    <item-input type="select" v-model="dic_ward_id" :options="operation_ward_auth" placeholder="请选择区域"></item-input>
                </el-col>
                <el-col :md="5" :xl="3">
                    <item-input type="remoteselect" v-model="dic_chrg_item_type_id" options="/api/AcisSystem/ChargeItem/SearchType" :clearable="true" placeholder="项目类别"></item-input>
                </el-col>
                <el-col :md="5" :xl="3" v-show="chargeType == 1">
                    <item-input type="select" v-model="searchchargeType" :clearable="true" :options="chargeTypes" placeholder="请选择计费类型"></item-input>
                </el-col>
            </slot>
            <template slot="filter-after"> <el-button type="primary" size="mini" @click="exportExcel">导出Excel</el-button></template>

            <div slot="table-title" class="align-left">&nbsp;共{{ statistic.count }}项, 总计金额：{{ statistic.total_price }}元</div>
        </crud-facecade>
        <cus-dialog class="table-h360" title="详情" :visible.sync="itemdetail.dialogFormVisible" :close-on-click-modal="false" width="80%" @confirm="closewbase()">
            <el-row type="flex" align="middle" style="margin-bottom: 10px">
                <el-col :md="24" class="align-right">
                    <el-button type="primary" size="mini" @click="exportExcelDetail">导出Excel</el-button>
                    <el-popover placement="bottom" :open-delay="600">
                        <el-button size="mini" plain slot="reference">
                            <font-awesome-icon :icon="['fas', 'cog']"></font-awesome-icon>
                            <span class="hidden-md-and-down">&nbsp;列配置</span>
                        </el-button>
                        <el-scrollbar wrap-class="scrollbar-wrapper-y" style="height: 250px; width: max-content">
                            <div class="config-column2">
                                <item-input type="checkboxgroup" :options="configColumns" v-model="user_config_columns"></item-input>
                            </div>
                        </el-scrollbar>

                        <el-divider></el-divider>
                        <div style="text-align: right">
                            <el-link type="primary" size="mini" class="margin-right10" @click="SaveUserColumns">保存</el-link>
                        </div>
                    </el-popover>
                </el-col>
            </el-row>
            <ListView ref="data-detail" :columns="userListColumn" :rowNoStyle="true" :datalist="itemdetail.datadetail"></ListView>
        </cus-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Sortable from 'sortablejs'
import XLSX from "xlsx"
import FileSaver from "file-saver"
export default {
    name: `QueryItemByDrug`,
    components: { },
    props: {},
    data() {
        return {
            title: `计费查询`,
            chargeType: this.$route.query.charge_type || 1,
            rdate: [
                this.$moment()
                    .add(-7, `days`)
                    .format(`YYYY/MM/DD`),
                this.$moment()
                    .add(1, `days`)
                    .format(`YYYY/MM/DD`)
            ],
            configColumns: [],
            user_config_columns: [],
            tableName: `jftj/Drug`,
            itemdetail: {
                dialogFormVisible: false,
                datadetail: 0
            },
            chargeStatisticsTime: this.$root.ChargeStatisticsTime,
            o_dic_ward_id: undefined,
            issetoperatingward: false,
            dic_chrg_item_type_id: undefined,
            statistic: {},
            url: {
                baseURL: ``,
                get: () => {
                    return this.loadSurgeries()
                },
                getOne: row => {
                    return Promise.resolve()
                },
                put: row => {
                    return Promise.resolve()
                }
            },
            searchchargeType: null,
            chargeTypes: [{ label: `麻醉计费`, value: 201 }, { label: `PACU计费`, value: 202 }],
            configChargeItemQueryDate: this.$root.ConfigChargeItemQueryDate
        }
    },
    created() {
        this.$store.dispatch(`ADD_SECTION_AUTH`)
        this.$store.dispatch(`drug/ADD_DRUG_TYPE`)
        if (this.chargeStatisticsTime && this.chargeStatisticsTime.trim() != `` && this.chargeStatisticsTime.trim() != `0`) {
            this.rdate = [
                this.$moment()
                    .add(-7, `days`)
                    .format(`YYYY/MM/DD ${this.chargeStatisticsTime}`),
                this.$moment()
                    .add(1, `days`)
                    .format(`YYYY/MM/DD ${this.chargeStatisticsTime}`)
            ]
        }
    },
    computed: {
        ...mapGetters([`ward_auth`, `active_ward`, `sys_enums`, `operation_ward_auth`, `drug/drug_type`, `section_auth`, `screenHeight`, `userConfigs`]),
        drugType() {
            return this[`drug/drug_type`]
        },
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        showTime() {
            if (this.chargeStatisticsTime && this.chargeStatisticsTime.trim() != `` && this.chargeStatisticsTime.trim() != `0`) {
                return this.chargeStatisticsTime
            }
            return null
        },
        dic_ward_id: {
            get: function() {
                if (!this.issetoperatingward && this.active_ward && this.active_ward.code == `手术区`) {
                    this.o_dic_ward_id = this.active_ward.origion
                }
                return this.o_dic_ward_id
            },
            set: function(v) {
                this.o_dic_ward_id = v
                this.issetoperatingward = true
            }
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `dic_chrg_item_type`,
                    label: `项目类别`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `项目名称`,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `spec`,
                    label: `规格`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `firm`,
                    label: `厂家`,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `amount`,
                    label: `计费数量`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `sell_unit`,
                    label: `计价单位`,
                    width: 80,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `price`,
                    label: `单价（元）`,
                    width: 80,
                    isListable: true
                },
                {
                    type: `float`,
                    prop: `total`,
                    label: `计费金额`,
                    width: 80,
                    isListable: true
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    width: `60`,
                    isListable: true,
                    readonly: false,
                    options: [
                        {
                            label: `详情`,
                            icon: ``,
                            type: `primary`,
                            emit: `OpenDetail`,
                            permission: `default`
                        }
                    ]
                }
            ]
        },
        detailcolumnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `id`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `fee_type`,
                    label: `类型`,
                    width: `80`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `visit_no`,
                    label: this.T(`byitem.visit_no`),
                    isListable: true,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `patient_name`,
                    label: `姓名`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_section`,
                    label: `科室`,
                    width: `100`,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `sex`,
                    label: `性别`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `age`,
                    label: `年龄`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgeries`,
                    label: `手术名称`,
                    width: `180`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `anaes_methods`,
                    label: `麻醉方式`,
                    width: `180`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `diseases`,
                    label: `诊断`,
                    width: `180`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `amount`,
                    label: `计费数量`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `sell_unit`,
                    label: `计价单位`,
                    width: 80,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `price`,
                    label: `单价（元）`,
                    width: 80,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `total_price`,
                    label: `计费金额`,
                    width: 80,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_chrg_item_type`,
                    label: `项目类别`,
                    width: 80,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgeon`,
                    label: this.T(`surgeryinfo.plan_surgeon`),
                    width: 80,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `doctorName`,
                    label: `开单人`,
                    width: 80,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `pay_type`,
                    label: `收费类别`,
                    width: 80,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `modifier`,
                    label: `收费人`,
                    width: 80,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `execute_dept`,
                    label: `执行科室`,
                    width: 80,
                    options: this[`section_auth`],
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `anes_charge_time`,
                    label: `计费日期`,
                    width: `180`,
                    sortable: true,
                    isListable: true
                }, {
                    type: `string`,
                    prop: `consumables_batch`,
                    label: `高值耗材编号`,
                    width: `140`,
                    isListable: true
                }
            ]
        },
        userListColumn() {
            let that = this
            if (this.configColumns.length == 0) {
                return this.detailcolumnList
            } else if (this.user_config_columns.length == 0) {
                // added by xiaorui,默认如果用户没有配置任何列 则 1.列配置勾选上当前页面所有列 2.展示当前列表上所有列
                that.user_config_columns = that.configColumns.map(c => c.value)
                return this.detailcolumnList
            }
            let allcolumn = _.filter(this.detailcolumnList, c => {
                return _.includes(this.user_config_columns, c.prop) || c.isExpand || c.isKey || (c.isDisplayOrder && c.isListable)
            })
            let r = _.orderBy(allcolumn, function(ac) {
                let i = _.findIndex(that.configColumns, { value: ac.prop })
                return i
            })
            console.log(r)
            return r
        }
    },
    methods: {
        exportExcel() {
            let that = this
            this.$nextTick(function() {
                var table = that.$refs[`data-list`].$refs[`cus-listView`].$refs[`cus-table`].$el
                var fileName = `计费项目_` + new Date().toLocaleDateString() + `.xlsx`
                var wb = XLSX.utils.table_to_book(table)
                /* get binary string as output */
                var wbout = XLSX.write(wb, {
                    bookType: `xlsx`,
                    bookSST: true,
                    type: `array`
                })
                try {
                    FileSaver.saveAs(
                        new Blob([wbout], { type: `application/octet-stream` }),
                        fileName
                    )
                } catch (e) {
                    console.log(e, wbout)
                }
                return wbout
            })
        },

        exportExcelDetail() {
            let that = this
            this.$nextTick(function() {
                var table = that.$refs[`data-detail`].$refs[`cus-table`].$el
                var fileName = `计费详情_` + new Date().toLocaleDateString() + `.xlsx`
                var wb = XLSX.utils.table_to_book(table)
                // console.log(wb)
                // let keys = Object.keys(wb.Sheets.Sheet1)
                // console.log(keys)
                // for (let key of keys) {
                //     // 导出的日期为第一列,A;不同的列数判断不同的英文序号
                //     if (key.indexOf(`R`) > -1) {
                //         // 修改z字段表示的日期格式
                //         wb.Sheets.Sheet1[key].z = `yyyy-mm-dd hh:mm`
                //     }
                // }
                // console.log(wb)
                // return
                /* get binary string as output */
                var wbout = XLSX.write(wb, {
                    bookType: `xlsx`,
                    bookSST: true,
                    type: `array`
                })
                try {
                    FileSaver.saveAs(
                        new Blob([wbout], { type: `application/octet-stream` }),
                        fileName
                    )
                } catch (e) {
                    console.log(e, wbout)
                }
                return wbout
            })
        },
        ExtraButtonClick(target) {
            if (this[target.emit]) {
                this[target.emit](target)
            } else {
                this.$emit(target.emit, target)
            }
        },
        OpenDetail({ row, index }) {
            // 获取开始时间
            var begin = this.$moment(this.rdate[0]).format(`YYYY/MM/DD HH:mm:00`)
            // 获取结束时间
            var end = this.$moment(this.rdate[1]).format(`YYYY/MM/DD HH:mm:59`)
            let req = this.myaxios.get(`/api/Nursing/Charge/GetItemsDetail?itemId=${row.id}&from=${begin}&to=${end}&wardId=${this.dic_ward_id}&chargeType=${this.searchchargeType || this.chargeType}`)
            req.then(data => {
                console.log(123)
                console.log(data)
                data = _.map(
                    _.filter(data, d => {
                        return d.charge_info.enum_charge_status == 1
                        // &&d.charge_info.enum_charge_type==this.chargeType
                    }),
                    d => {
                        d.id = d.charge_info.id
                        d.consumables_batch = d.charge_info.consumables_batch
                        d.spec = d.charge_info.spec
                        d.firm = d.charge_info.firm
                        d.sell_unit = d.charge_info.dic_chrg_item.sell_unit
                        d.price = d.charge_info.price
                        d.total_price = d.charge_info.enum_fee_type * d.charge_info.total_price
                        d.dic_chrg_item_type = d.charge_info.dic_chrg_item.dic_chrg_item_type
                        d.pay_type = d.charge_info.pay_type
                        d.modifier = d.charge_info.modifier
                        d.doctor = d.charge_info.doctor
                        d.doctorName = d.charge_info.doctorName
                        d.execute_dept = d.charge_info.execute_dept
                        d.anes_charge_time = d.charge_info.submit_date
                        d.visit_no = d.surgery_info.visit_no
                        d.dic_section = d.surgery_info.dic_section
                        d.sex = d.surgery_info.sex
                        d.age = d.surgery_info.age
                        d.patient_name = d.surgery_info.patient_name
                        d.surgeon = d.surgery_info.surgeon
                        d.surgeries = d.surgery_info.surgeries
                        d.anaes_methods = d.surgery_info.anaes_methods
                        d.diseases = d.surgery_info.diseases
                        d.amount = d.charge_info.amount
                        d.fee_type = d.charge_info.fee_type
                        // d.class_name=`fee-type${d.charge_info.enum_fee_type}`
                        // d.class_name=d.charge_info.enum_fee_type==-1?'fg-danger':''
                        return d
                    }
                )
                this.itemdetail.datadetail = data
                this.itemdetail.dialogFormVisible = true
                this.loadConfigColumns()
            })
        },
        loadSurgeries() {
            // 加载计费患者
            let maxday = 31
            if (this.configChargeItemQueryDate && parseInt(this.configChargeItemQueryDate)) {
                maxday = this.configChargeItemQueryDate
            }
            if (!this.dic_ward_id) {
                return Promise.resolve([])
            }
            if (
                this.$moment(this.rdate[0])
                    .add(maxday, `days`)
                    .isBefore(this.$moment(this.rdate[1]))
            ) {
                this.$message.warning(`最多查询${this.configChargeItemQueryDate || `31`}天`)
                return Promise.resolve([])
            }
            // 获取开始时间
            var begin = this.$moment(this.rdate[0]).format(`YYYY/MM/DD HH:mm:00`)
            // 获取结束时间
            var end = this.$moment(this.rdate[1]).format(`YYYY/MM/DD HH:mm:59`)
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/Nursing/Charge/GetChargedItems?wardId=${this.dic_ward_id}&chargeType=${this.searchchargeType || this.chargeType}&from=${begin}&to=${end}`)
                req.then(data => {
                    let r = _.filter(data, d => {
                        return !this.dic_chrg_item_type_id || d.dic_chrg_item_type_id == this.dic_chrg_item_type_id.value
                    })
                    _.map(r, (d, index) => {
                        d.total = parseFloat(d.total).toFixed(2)
                    })
                    console.log(r)
                    this.statistic = {
                        count: r.length,
                        total_price: _.sumBy(r, d => d.total * 1).toFixed(2)
                    }
                    resolve(r)
                }).catch(e => reject(e))
            })
        },
        ReloadListData() {
            this.$refs[`data-list`].ReloadListData()
        },
        closewbase() {
            this.itemdetail.dialogFormVisible = false
        },
        loadConfigColumns() {
            let that = this
            let req = this.myaxios.get(`api/AcisSystem/SystemServer/GetColumnConfig?tableName=${this.tableName}`)
            req.then(data => {
                let lcs = []
                if (data && data.length > 0) {
                    lcs = _.orderBy(that.detailcolumnList, function(lc) {
                        return _.findIndex(data, { col_name: lc.prop })
                    })
                    that.configColumns = lcs.map(c => {
                        return { value: c.prop, label: c.label }
                    }).filter(d => {
                        return d.label != `unique` && d.label != `id`
                    })
                    that.user_config_columns = (data && _.filter(data, { enabled: true }).map(d => d.col_name)) || []
                } else {
                    lcs = that.detailcolumnList.filter(d => {
                        return d.prop != `id`
                    })
                    that.configColumns = lcs.map(c => {
                        return { value: c.prop, label: c.label }
                    }).filter(d => {
                        return d.label != `id`
                    })
                    that.user_config_columns = that.configColumns.map(d => d.value) || []
                }
                if (this.itemdetail.dialogFormVisible == true) {
                    that.configColumnDrop()
                }

                console.log(that.user_config_columns)
            })
        },
        SaveUserColumns() {
            let that = this
            let uc = this.configColumns.map((c, index) => {
                return {
                    col_name: c.value,
                    display_order: index,
                    enabled: _.includes(this.user_config_columns, c.value),
                    table_name: that.tableName
                }
            })
            let req = this.myaxios.post(`/api/AcisSystem/SystemServer/SetColumnConfig`, uc)
            req.then(data => {
                this.$message.success(`保存成功`)
                if (this.reload) {
                    this.reload()
                }
            }).catch(e => {})
        },
        configColumnDrop() {
            // if (!this.columnConfig) return
            const tbody = document.querySelector(`.config-column2 .el-checkbox-group`)
            console.log(tbody)
            const _this = this
            Sortable.create(tbody, {
                group: { name: `config-column`, push: false, put: false },
                animation: 180,
                fallbackOnBody: true,
                delay: 0,
                onUpdate({ newIndex, oldIndex }) {
                    // 交换排序
                    if (newIndex == oldIndex) return
                    // console.log({ newIndex, oldIndex })
                    const currRow = _this.configColumns.splice(oldIndex, 1)[0]
                    _this.configColumns.splice(newIndex, 0, currRow)
                }
            })
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.chargeType = newUrl.query.charge_type
            this.ReloadListData()
        },
        dic_ward_id: function() {
            this.ReloadListData()
        },
        rdate: function() {
            this.ReloadListData()
        },
        dic_chrg_item_type_id: function() {
            this.ReloadListData()
        },
        searchchargeType: function() {
            this.ReloadListData()
        }
    }
}
</script>
<style scoped>
.config-column2 {
    width: 150px;
    overflow: hidden;
    margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Charge/QueryItemByDrug.vue